module.exports = __webpack_public_path__ + "img/s_purplegreenR-logo.a121dbf.png";